/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why does compound interest grow faster over time?`)
};

const es_cp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué crece más rápido el interés compuesto con el tiempo?`)
};

const de_cp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum wächst Zinseszins im Laufe der Zeit schneller?`)
};

const nl_cp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom groeit samengestelde rente sneller in de loop van de tijd?`)
};

const fr_cp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi l'intérêt composé croît-il plus rapidement au fil du temps ?`)
};

const it_cp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché l'interesse composto cresce più velocemente nel tempo?`)
};

const pt_br2_cp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que os juros compostos crescem mais rápido ao longo do tempo?`)
};

const pt_cp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que o juro composto cresce mais rapidamente ao longo do tempo?`)
};

const ja_cp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複利がなぜ時間とともに速く成長するのか?`)
};

const zh_cp_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么复利会随着时间增长得更快？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_faq4_q", locale)
	if (locale === "en") return en_cp_faq4_q(inputs)
	if (locale === "es") return es_cp_faq4_q(inputs)
	if (locale === "de") return de_cp_faq4_q(inputs)
	if (locale === "nl") return nl_cp_faq4_q(inputs)
	if (locale === "fr") return fr_cp_faq4_q(inputs)
	if (locale === "it") return it_cp_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_cp_faq4_q(inputs)
	if (locale === "pt") return pt_cp_faq4_q(inputs)
	if (locale === "ja") return ja_cp_faq4_q(inputs)
	return zh_cp_faq4_q(inputs)
};